import ModalContext from 'contexts/ModalContext'
import React, { ComponentProps, useCallback, useContext } from 'react'
import LoyaltyGenericInfoModal from '../LoyaltyGenericInfoModal'
import _LoyaltyPointsEarn from './_LoyaltyPointsEarn'

type InheritedPriceRowLoyaltyPointsProps = Omit<ComponentProps<typeof _LoyaltyPointsEarn>, 'onInfoIconClick'>

interface Props extends InheritedPriceRowLoyaltyPointsProps {
  /** If true, do not render the info icon/modal trigger */
  hideInfoIcon?: boolean;
}

function LoyaltyPointsEarn({ calculationRequests, hideInfoIcon, ...rest }: Props) {
  const showModal = useContext(ModalContext)
  const handleInfoClick = useCallback(() => {
    showModal(<LoyaltyGenericInfoModal calculationRequests={calculationRequests} />)
  }, [showModal, calculationRequests])

  return <_LoyaltyPointsEarn
    {...rest}
    calculationRequests={calculationRequests}
    onInfoIconClick={hideInfoIcon ? undefined : handleInfoClick}
  />
}

export default LoyaltyPointsEarn
